var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",style:(_vm.loaderStyle)},[_c('font-awesome-icon',{style:(_vm.fontAwesomeStyle),attrs:{"size":"9x","icon":"spinner","spin":"","pulse":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }